import { render, staticRenderFns } from "./RemoveLogoDialog.vue?vue&type=template&id=62664b58&scoped=true"
import script from "./RemoveLogoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoveLogoDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RemoveLogoDialog.vue?vue&type=style&index=0&id=62664b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62664b58",
  null
  
)

export default component.exports